import React from 'react';
import { subscribe } from 'reffects-store';
import { IS_NEW_CRITERION } from 'components/UnifiedCampaignForm/constants';
import SegmentationCriterionWrapper from './SegmentationCriterionWrapper';
import { segmentationCriterionSelector } from '../selectors';
import CriteriaIsOrIsNot from './CriteriaInputs/CriteriaIsOrIsNot';
import {
    onRemoveCriterion,
    onChangeCriterionOperation,
} from './eventDispatchers';

function IsNewCriterion({
    visible,
    operation,
    field,
    value,
    label,
    onRemove,
    onChangeOperation,
}) {
    return (
        <SegmentationCriterionWrapper
            visible={visible}
            label={label}
            field={field}
            value={value}
            onRemove={onRemove}
        >
            <CriteriaIsOrIsNot
                operation={operation}
                field={field}
                onChangeCriteriaOperation={onChangeOperation}
            />
        </SegmentationCriterionWrapper>
    );
}

export default subscribe(
    IsNewCriterion,
    function mapStateToProps(state) {
        const segmentationCriterion =
            segmentationCriterionSelector(IS_NEW_CRITERION)(state);

        return { ...segmentationCriterion };
    },
    {
        onRemove: onRemoveCriterion,
        onChangeOperation: onChangeCriterionOperation,
    }
);
